import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

import GenericButton from '../../common/GenericButton';
import TeamListItems from './TeamListItems';
import { getTeamDetails } from '../../../actions/teamActions';

class TeamListBox extends Component {
  static propTypes = {
    teams: PropTypes.instanceOf(Array),
    activeTeams: PropTypes.instanceOf(Array),
    updateSelectedItems: PropTypes.func,
    clearItems: PropTypes.bool,
  }

  static defaultProps = {
    teams: [],
    activeTeams: [],
    clearItems: false,
  }

  state = {
    items: [],
    itemsLeft: [],
    selectedItemsLeft: [],
    itemsRight: [],
    selectedItemsRight: [],
    rightSelectionCount: 0,
    originalBaseLists: [],
    teams: [],
  };


  UNSAFE_componentWillMount() {
    this.setState({ teams: this.props.teams }, () => {
      this.updateInitialState();
    });
  }

  UNSAFE_componentWillReceiveProps({ clearItems, activeTeams, teams }) {
    if (clearItems !== this.props.clearItems) {
      this.removeAll();
    }

    if (!_.isEqual(teams, this.state.teams)) {
      this.setState({ teams }, () => {
        this.updateInitialState();
      });
    }

    if (!_.isEqual(activeTeams, this.state.itemsRight)) {
      this.setState({
        items: [],
        itemsLeft: [],
        selectedItemsLeft: [],
        itemsRight: [],
        selectedItemsRight: [],
        rightSelectionCount: 0,
        originalBaseLists: [],
      }, () => {
        this.updateInitialState();
      });
    }
  }

  updateInitialState = () => {
    const teams = this.renderTeamData();
    const selectedItemsLeft = [];
    teams.map((team, i) => {
      if (team.isActive) {
        selectedItemsLeft.push(i);
      }
      return null;
    });
    this.setState({
      items: teams,
      itemsLeft: teams,
      selectedItemsLeft,
      originalBaseLists: teams,
    }, () => {
      if (selectedItemsLeft.length > 0) {
        this.addSelected();
      }
    });
  }

  handleSearch = searchResult => this.setState({ itemsLeft: searchResult });

  handleLeftPanelClick = (itemId, clearExisting, shiftKey) => {
    let selectedItems = [];
    if (!shiftKey) {
      if (!clearExisting) {
        selectedItems = this.state.selectedItemsLeft;
      }
      selectedItems.push(parseInt(itemId, 10));
      this.setState({
        selectedItemsLeft: selectedItems,
      });
    } else {
      selectedItems = this.state.selectedItemsLeft;
      let lastItem = this.state.selectedItemsLeft.pop();
      let currentItemId = itemId;
      if (lastItem > currentItemId) {
        const temp = lastItem;
        lastItem = currentItemId;
        currentItemId = temp;
      }
      this.state.itemsLeft.map(item => {
        if (item.itemId >= lastItem && item.itemId <= parseInt(currentItemId, 10)) {
          selectedItems.push(item.itemId);
        }
        return item;
      });
      this.setState({
        selectedItemsLeft: selectedItems,
      });
    }
  };

  addSelected = () => {
    const selections = [];
    const itemsRemaining = [];
    this.state.itemsLeft.map(item => {
      if (item.selected) {
        selections.push(item);
      } else {
        itemsRemaining.push(item);
      }
      return item;
    });

    this.state.itemsRight.map(item => {
      selections.push(item);
      return item;
    });
    this.setState({
      itemsLeft: itemsRemaining,
      itemsRight: selections,
      rightSelectionCount: selections.length,
      selectedItemsRight: [],
      selectedItemsLeft: [],
    }, () => {
      this.props.updateSelectedItems(this.state.itemsRight);
    });
  };

  removeSelected = () => {
    const selections = [];
    const itemsRemaining = [];
    this.state.itemsRight.map(item => {
      if (item.selected) {
        selections.push(item);
      } else {
        itemsRemaining.push(item);
      }
      return item;
    });

    this.state.itemsLeft.map(item => {
      selections.push(item);
      return item;
    });
    this.setState({
      itemsLeft: selections,
      itemsRight: itemsRemaining,
      rightSelectionCount: itemsRemaining.length,
      selectedItemsRight: [],
      selectedItemsLeft: [],
    }, () => {
      this.props.updateSelectedItems(this.state.itemsRight);
    });
  };

  handleMoveAllLeft = () => {
    const { itemsLeft, itemsRight } = this.state;
    const allItemsToLeft = itemsRight;
    _.map(itemsLeft, item => {
      allItemsToLeft.push(item);
    });
    this.setState({
      itemsLeft: allItemsToLeft,
      itemsRight: [],
      rightSelectionCount: 0,
      selectedItemsRight: [],
      selectedItemsLeft: [],
    }, () => {
      this.props.updateSelectedItems([]);
    });
  }

  handleMoveAllRight = () => {
    const { itemsLeft, itemsRight } = this.state;
    const allItemsToRight = itemsLeft;
    _.map(itemsRight, item => {
      allItemsToRight.push(item);
    });
    this.setState({
      itemsRight: allItemsToRight,
      itemsLeft: [],
      selectedItemsLeft: [],
      selectedItemsRight: [],
    }, () => {
      this.props.updateSelectedItems(this.state.itemsRight);
    });
  }

  removeAll = () => {
    const leftPanelItems = [];
    leftPanelItems.push(...this.state.itemsLeft, ...this.state.itemsRight);
    this.setState({
      itemsRight: [],
      itemsLeft: leftPanelItems,
      rightSelectionCount: 0,
      selectedItemsRight: [],
      selectedItemsLeft: [],
    }, () => {
      this.props.updateSelectedItems(this.state.itemsRight);
    });
  };

  handleRightPanelClick = (itemId, clearExisting, shiftKey) => {
    let selectedItems = [];
    if (!shiftKey) {
      if (!clearExisting) {
        selectedItems = this.state.selectedItemsRight;
      }
      selectedItems.push(parseInt(itemId, 10));
      this.setState({
        selectedItemsRight: selectedItems,
      });
    } else {
      selectedItems = this.state.selectedItemsRight;
      let lastItem = this.state.selectedItemsRight.pop();
      let currentItemId = itemId;
      if (lastItem > currentItemId) {
        const temp = lastItem;
        lastItem = currentItemId;
        currentItemId = temp;
      }
      this.state.itemsRight.map(item => {
        if (item.itemId >= lastItem && item.itemId <= parseInt(currentItemId, 10)) {
          selectedItems.push(item.itemId);
        }
        return item;
      });
      this.setState({
        selectedItemsRight: selectedItems,
      });
    }
  };

  renderTeamData = () => {
    const teams = this.state.teams;
    const activeTeams = this.props.activeTeams;
    const items = teams.map((team, index) => {
      const activeTeam = _.filter(activeTeams, item => item.id === team.id);
      const selected = activeTeam.length > 0;
      const items = {
        ...team,
        itemId: index,
        text: team.name,
        selected: false,
        isActive: selected,
        children: [],
      };
      return items;
    });
    return items;
  }

  renderSearchItems = () => {
    const { items, itemsRight } = this.state;
    const filteredItems = [];
    _.map(items, item => {
      const hasItem = _.filter(itemsRight, k => k.id === item.id);
      if (_.isEmpty(hasItem)) {
        filteredItems.push(item);
      }
    });
    return filteredItems;
  }

  handleExpendTree = (e, id, hasChild, position) => {
    e.stopPropagation();
    let positionItem = _.cloneDeep(this.state.itemsLeft);
    if (position === 'right') {
      positionItem = _.cloneDeep(this.state.itemsRight);
    }
    if (hasChild) {
      const items = _.map(positionItem, item => {
        let children = item.children;
        if (item.id === id) {
          children = [];
        }
        const data = {
          ...item,
          children,
        };
        return data;
      });
      if (position === 'right') {
        this.setState({ itemsRight: items, disableButtons: false });
      } else {
        this.setState({ itemsLeft: items, disableButtons: false });
      }
    } else {
      this.setState({ disableButtons: true }, () => {
        getTeamDetails(id)
          .then(response => {
            const items = _.map(positionItem, item => {
              let children = item.children;
              if (response && item.id === id) {
                children = response.users;
              }
              const data = {
                ...item,
                children,
              };
              return data;
            });
            if (position === 'right') {
              this.setState({ itemsRight: items, disableButtons: false });
            } else {
              this.setState({ itemsLeft: items, disableButtons: false });
            }
          });
      });
    }
  }

  render() {
    return (
      <div className="multi-select-search-component">
        <div className="add-user-form--row">
          <div className="add-user-form--col">
            <div className="base-left-label">Available Team(s)</div>
            <TeamListItems
              items={this.state.itemsLeft}
              selectedItems={this.state.selectedItemsLeft}
              handleSelection={this.handleLeftPanelClick}
              handleExpendTree={this.handleExpendTree}
              position="left"
            />
          </div>
          <div className="add-user-form--col-center add-user-form--col">
            <div className="stacked button-group multi-select-button-group">
              <GenericButton
                name=" "
                btnStyle="button btn-add btn-priaryDisable"
                onBtnClick={this.addSelected}
                {...(this.state.selectedItemsLeft.length < 1
                  ? { btnDisabled: true }
                  : {})}
              />

              <GenericButton
                name=" "
                btnStyle="button btn-add-all btn-priaryDisable"
                onBtnClick={this.handleMoveAllRight}
                {...(this.state.itemsLeft.length < 1
                  ? { btnDisabled: true }
                  : {})}
              />

              <GenericButton
                name=" "
                btnStyle="button btn-remove btn-cncl"
                onBtnClick={this.removeSelected}
                {...(this.state.selectedItemsRight.length < 1
                  ? { btnDisabled: true }
                  : {})}
              />

              <GenericButton
                name=" "
                btnStyle="button btn-remove-all btn-priaryDisable"
                onBtnClick={this.handleMoveAllLeft}
                {...(this.state.itemsRight.length < 1
                  ? { btnDisabled: true }
                  : {})}
              />
            </div>
          </div>
          <div className="add-user-form--col">
            <div className="base-left-label">Selected Team(s)</div>
            <TeamListItems
              items={this.state.itemsRight}
              selectedItems={this.state.selectedItemsRight}
              handleSelection={this.handleRightPanelClick}
              handleExpendTree={this.handleExpendTree}
              position="right"
            />
          </div>
        </div>
      </div>
    );
  }
}

export default TeamListBox;
